export default function DealsEmptyState() {
  return 'No deals have been created for this property';
}
